import { render, staticRenderFns } from "./QyChannel.vue?vue&type=template&id=015243b7&scoped=true&"
import script from "./QyChannel.vue?vue&type=script&lang=js&"
export * from "./QyChannel.vue?vue&type=script&lang=js&"
import style0 from "./QyChannel.vue?vue&type=style&index=0&id=015243b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015243b7",
  null
  
)

export default component.exports